import SuperAdminDashboardCard from "../../../components/ui/dashboard/SuperAdminDashboardCard";
import { formatCurrencyForTable } from "../../../lib/utils";
import { useGetTransactionStatsQuery } from "../transactionApiSlice";

const TransactionStats = () => {
  const { data, isLoading } = useGetTransactionStatsQuery(undefined, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    refetchOnReconnect: true,
    skipPollingIfUnfocused: true,
    // pollingInterval: 20000,
  });

  const transactionStat = data?.data ?? {
    totalRevenueThisMonth: 0,
    completedTransactions: 0,
    pendingTransactions: 0,
    failedTransactions: 0,
  };

  const cards = [
    {
      label: "Total revenue this month",
      value: `${formatCurrencyForTable(transactionStat.totalRevenueThisMonth)}`,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          className="text-primary h-8 w-8"
        >
          <g fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M16.755 2h-9.51c-1.159 0-1.738 0-2.206.163a3.05 3.05 0 0 0-1.881 1.936C3 4.581 3 5.177 3 6.37v14.004c0 .858.985 1.314 1.608.744a.946.946 0 0 1 1.284 0l.483.442a1.657 1.657 0 0 0 2.25 0a1.657 1.657 0 0 1 2.25 0a1.657 1.657 0 0 0 2.25 0a1.657 1.657 0 0 1 2.25 0a1.657 1.657 0 0 0 2.25 0l.483-.442a.946.946 0 0 1 1.284 0c.623.57 1.608.114 1.608-.744V6.37c0-1.193 0-1.79-.158-2.27a3.05 3.05 0 0 0-1.881-1.937C18.493 2 17.914 2 16.755 2Z" />
            <path
              stroke-linecap="round"
              d="M10.5 11H17M7 11h.5M7 7.5h.5m-.5 7h.5m3-7H17m-6.5 7H17"
            />
          </g>
        </svg>
      ),
      index: 0,
      bg: "bg-primary/10",
    },
    {
      label: "Completed transactions",
      value: `${formatCurrencyForTable(transactionStat.completedTransactions)}`,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          className="text-green-500 h-8 w-8"
        >
          <g fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M16.755 2h-9.51c-1.159 0-1.738 0-2.206.163a3.05 3.05 0 0 0-1.881 1.936C3 4.581 3 5.177 3 6.37v14.004c0 .858.985 1.314 1.608.744a.946.946 0 0 1 1.284 0l.483.442a1.657 1.657 0 0 0 2.25 0a1.657 1.657 0 0 1 2.25 0a1.657 1.657 0 0 0 2.25 0a1.657 1.657 0 0 1 2.25 0a1.657 1.657 0 0 0 2.25 0l.483-.442a.946.946 0 0 1 1.284 0c.623.57 1.608.114 1.608-.744V6.37c0-1.193 0-1.79-.158-2.27a3.05 3.05 0 0 0-1.881-1.937C18.493 2 17.914 2 16.755 2Z" />
            <path
              stroke-linecap="round"
              d="M10.5 11H17M7 11h.5M7 7.5h.5m-.5 7h.5m3-7H17m-6.5 7H17"
            />
          </g>
        </svg>
      ),
      index: 1,
      bg: "bg-green-50",
    },
    {
      label: "Pending transactions",
      value: `${formatCurrencyForTable(transactionStat.pendingTransactions)}`,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          className="text-yellow-500 h-8 w-8"
        >
          <g fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M16.755 2h-9.51c-1.159 0-1.738 0-2.206.163a3.05 3.05 0 0 0-1.881 1.936C3 4.581 3 5.177 3 6.37v14.004c0 .858.985 1.314 1.608.744a.946.946 0 0 1 1.284 0l.483.442a1.657 1.657 0 0 0 2.25 0a1.657 1.657 0 0 1 2.25 0a1.657 1.657 0 0 0 2.25 0a1.657 1.657 0 0 1 2.25 0a1.657 1.657 0 0 0 2.25 0l.483-.442a.946.946 0 0 1 1.284 0c.623.57 1.608.114 1.608-.744V6.37c0-1.193 0-1.79-.158-2.27a3.05 3.05 0 0 0-1.881-1.937C18.493 2 17.914 2 16.755 2Z" />
            <path
              stroke-linecap="round"
              d="M10.5 11H17M7 11h.5M7 7.5h.5m-.5 7h.5m3-7H17m-6.5 7H17"
            />
          </g>
        </svg>
      ),
      index: 2,
      bg: "bg-yellow-50",
    },
    {
      label: "Failed transactions",
      value: `${formatCurrencyForTable(transactionStat.failedTransactions)}`,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          className="text-red-500 h-8 w-8"
        >
          <g fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M16.755 2h-9.51c-1.159 0-1.738 0-2.206.163a3.05 3.05 0 0 0-1.881 1.936C3 4.581 3 5.177 3 6.37v14.004c0 .858.985 1.314 1.608.744a.946.946 0 0 1 1.284 0l.483.442a1.657 1.657 0 0 0 2.25 0a1.657 1.657 0 0 1 2.25 0a1.657 1.657 0 0 0 2.25 0a1.657 1.657 0 0 1 2.25 0a1.657 1.657 0 0 0 2.25 0l.483-.442a.946.946 0 0 1 1.284 0c.623.57 1.608.114 1.608-.744V6.37c0-1.193 0-1.79-.158-2.27a3.05 3.05 0 0 0-1.881-1.937C18.493 2 17.914 2 16.755 2Z" />
            <path
              stroke-linecap="round"
              d="M10.5 11H17M7 11h.5M7 7.5h.5m-.5 7h.5m3-7H17m-6.5 7H17"
            />
          </g>
        </svg>
      ),
      index: 2,
      bg: "bg-red-50",
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-3 sm:flex sm:gap-5 sm:justify-between">
      {cards.map(({ label, value, icon, bg, index }) => (
        <>
          <SuperAdminDashboardCard
            key={index}
            icon={icon}
            value={isLoading ? "0" : value}
            label={label}
            className="w-[300px]"
            iconBg={bg}
          />
        </>
      ))}
    </div>
  );
};

export default TransactionStats;
